/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandAppgallery = createReactComponent("outline", "brand-appgallery", "IconBrandAppgallery", [["path", { "d": "M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z", "key": "svg-0" }], ["path", { "d": "M9 8a3 3 0 0 0 6 0", "key": "svg-1" }]]);

export { IconBrandAppgallery as default };
//# sourceMappingURL=IconBrandAppgallery.mjs.map
